module.exports = __webpack_public_path__ + "static/media/testimonial1.507e6847.png";